import { Stack, StackProps } from "@mui/material";
import { PropsWithChildren } from "react";

export function ReviewVisitTableCell({ children, ...stackProps }: PropsWithChildren & StackProps) {
    return (
        <Stack
            padding={2}
            sx={theme => ({
                borderTop: `1px solid ${theme.palette.divider}`,
            })}
            {...stackProps}
        >
            {children}
        </Stack>
    );
}
